import { observer } from 'mobx-react-lite'
import { Phone } from 'iconoir-react'
import { ReactElement } from 'react'
import { CallDrawer } from 'app/components/calls/CallDrawer'
import { PageScroll } from 'app/components/layout/PageScroll'
import Spinner from 'app/components/Spinner'
import TableLayout from 'app/components/table/TableLayout'
import { PageHeader } from 'app/components/PageHeader'
import { TableEmptyState } from 'app/components/ui/table-empty-state'
import type { UseCallsReturn } from './useCalls'

export type CallsComponentProps = UseCallsReturn

export const CallsComponent = observer(function CallsComponent({
  calls,
  columns,
  filterableColumns,
  slug,
  isLoading,
  openDrawer,
  focusedCall,
  location,
  onCloseDrawer,
  onCallUpdate,
}: CallsComponentProps): ReactElement {
  return (
    <PageScroll variant="table" header={<PageHeader title="Calls" totalItems={calls?.total ?? 0} />}>
      {calls ? (
        <TableLayout
          key={slug}
          columns={columns}
          filterableColumns={filterableColumns}
          data={!isLoading ? calls : undefined}
          drawer={
            focusedCall ? (
              <CallDrawer
                open={openDrawer}
                call={focusedCall}
                location={location}
                onCallUpdate={onCallUpdate}
                onClose={onCloseDrawer}
              />
            ) : null
          }
          meta={{ getRowStyle: (row: any) => (row?.id === focusedCall?.id ? `table-selected-row` : ``) }}
          edgePadded
          emptyState={
            <TableEmptyState
              icon={<Phone className="h-6 w-6" strokeWidth={1.5} />}
              title="No calls yet"
              description="Every call to a tracked number lands here with the caller, the location they reached, and how long it lasted."
            />
          }
        />
      ) : (
        <Spinner size={10} />
      )}
    </PageScroll>
  )
})
